import { Box, Button, HStack, Stack, Text, VStack } from "@chakra-ui/react";
import { MdAccessTimeFilled, MdEmail, MdPhoneEnabled } from "../../customIcons";

import { Fb } from "../../atoms/Fb";
import { Instagram } from "../../atoms/Instagram";
import { Link } from "gatsby";
import { LinkedIn } from "../../atoms/LinkedIn";
import { Logo } from "../../atoms/Logo";
import { MasterCardLogo } from "../../atoms/MasterCardLogo";
import Newsletter from "../Newsletter";
import React from "react";
import { VisaLogo } from "../../atoms/VisaLogo";
import useAuth from "../../useAuth";

const Footer = () => {
  const { isBankAcc, isOtherBankUser, isBankUser3, isBankUserEu } = useAuth();

  const today = new Date();

  const pathname = typeof window !== "undefined" && window.location?.pathname;

  const currentlyOnShopPage = pathname === "/shop/";
  const reloadPage = (): void => {
    if (typeof window !== "undefined") {
      const newURL = new URL(window?.location.href);
      newURL.search = "";
      window.location.href = newURL.toString();
    }
  };

  return (
    <Box maxW="1280px" width="100%">
      <Box
        bg="#FFF5F7"
        py={{ base: "20px", lg: "80px" }}
        px={{ base: "20px" }}
        pb={{ base: "80px", lg: "40px" }}
      >
        <Newsletter />
        <VStack p={0}>
          <Box mt="40px" mb="40px" width="100%" alignItems="flex-start">
            <a href="https://www.medsupplysolutions.com/">
              <Logo
                textColor="#DBA4B9"
                dotsColor="#A24468"
                height={{ base: "48px", md: "80px" }}
                width={{ base: "178px", md: "296px" }}
                color="#000"
              />
            </a>
          </Box>

          <Stack
            gap={0}
            width="100%"
            flexDirection={{ base: "column", sm: "row" }}
          >
            <HStack
              flexDirection={{ base: "column", md: "row" }}
              alignItems={{ base: "center", mp: "flex-start" }}
              width="100%"
              justifyContent={{ base: "flex-start", md: "space-around" }}
            >
              <VStack gap={0} width="100%" alignItems="flex-start">
                <HStack gap={0}>
                  <MdPhoneEnabled w="22px" h="22px" fill="#BB5D82" />
                  <VStack gap={0} ml={4} alignItems="flex-start">
                    <Text color="#BB5D82" fontSize="16px" fontWeight="700">
                      Phone/Text
                    </Text>

                    <Text color="#3B2060" fontSize="14px">
                      <a href="tel:+1-844-226-8277">+1-844-226-8277</a>
                    </Text>

                    <Text color="#3B2060" fontSize="14px">
                      <a href="tel:+1-844-647-2698">+1-844-647-2698</a>
                    </Text>
                  </VStack>
                </HStack>

                <HStack gap={0} mt={6}>
                  <MdEmail w="20px" h="20px" fill="#BB5D82" />
                  <VStack gap={0} ml={4} alignItems="flex-start">
                    <Text color="#BB5D82" fontSize="16px" fontWeight="700">
                      E-mail
                    </Text>

                    <Text color="#3B2060" fontSize="14px">
                      <a href="mailto:info@medsupplysolutions.com">
                        info@medsupplysolutions.com
                      </a>
                    </Text>
                  </VStack>
                </HStack>

                <HStack gap={0} mt={6}>
                  <MdEmail w="20px" h="20px" fill="#BB5D82" />
                  <VStack gap={0} ml={4} alignItems="flex-start">
                    <Text color="#BB5D82" fontSize="16px" fontWeight="700">
                      Share feedback at:
                    </Text>

                    <Text color="#3B2060" fontSize="14px">
                      <a href="mailto:support@medsupplysolutions.com">
                        support@medsupplysolutions.com
                      </a>
                    </Text>
                  </VStack>
                </HStack>

                <HStack gap={0} mt={6}>
                  <MdAccessTimeFilled w="20px" h="20px" color="#BB5D82" />
                  <VStack gap={0} ml={4} alignItems="flex-start">
                    <Text color="#BB5D82" fontSize="16px" fontWeight="700">
                      Working Hours
                    </Text>
                    <Text color="#3B2060" fontSize="14px">
                      Monday to Friday: 9 AM to 6 PM EST
                    </Text>
                  </VStack>
                </HStack>

                <Button
                  ml={8}
                  mt={6}
                  bgColor="#3B2060"
                  h="48px"
                  color="white"
                  _hover={{ bg: "#6A3AAB" }}
                >
                  <a
                    href="https://medsupplysolutions.youcanbook.me/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Book a Meeting
                  </a>
                </Button>
                <HStack pt={4} ml={7}>
                  <Link
                    target="_blank"
                    rel="noopener"
                    to="https://ca.linkedin.com/company/medsupply-solutions?trk=public_post_feed-actor-name"
                  >
                    <LinkedIn height="28px" weight="28px" />
                  </Link>

                  <Link
                    target="_blank"
                    rel="noopener"
                    to="https://www.facebook.com/medsupplysolutionsofficial"
                  >
                    <Fb height="28px" weight="28px" />
                  </Link>
                  <Link
                    target="_blank"
                    rel="noopener"
                    to="https://www.instagram.com/medsupplysolutions/?hl=en"
                  >
                    <Instagram
                      marginBottom={-1}
                      marginRight={-1}
                      height="30px"
                      weight="30px"
                    />
                  </Link>
                </HStack>
              </VStack>

              <VStack
                ml={{ base: "0px", md: "40px", "2xl": "100px" }}
                width="100%"
                alignItems="flex-start"
              >
                <Text
                  pt={{ base: "40px", md: "0px" }}
                  color="#BB5D82"
                  fontSize="16px"
                  fontWeight="700"
                >
                  The Most Popular Brands
                </Text>

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/juvederm/">
                    JUVÉDERM® fillers
                  </a>
                </Button>

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/restylane/">
                    RESTYLANE® fillers
                  </a>
                </Button>

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/profhilo/">
                    PROFHILO® injections
                  </a>
                </Button>

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/radiesse/">
                    RADIESSE® fillers
                  </a>
                </Button>
              </VStack>

              <VStack
                ml={{ base: "0px", md: "40px", "2xl": "100px" }}
                width="100%"
                alignItems="flex-start"
              >
                <Text
                  pt={{ base: "40px", md: "0px" }}
                  color="#BB5D82"
                  fontSize="16px"
                  fontWeight="700"
                >
                  Med Supply Solutions
                </Text>

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/about-us/">
                    About Us
                  </a>
                </Button>

                {currentlyOnShopPage ? (
                  <Button
                    color="#3B2060"
                    fontSize="14px"
                    _hover={{ background: "none" }}
                    variant="unstyled"
                    onClick={reloadPage}
                  >
                    <a href="https://www.medsupplysolutions.com/shop/">
                      All Products
                    </a>
                  </Button>
                ) : (
                  <Button
                    color="#3B2060"
                    fontSize="14px"
                    _hover={{ background: "none" }}
                    variant="unstyled"
                  >
                    <a href="https://www.medsupplysolutions.com/shop/">
                      All Products
                    </a>
                  </Button>
                )}

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/price-match/">
                    Price Match Program
                  </a>
                </Button>

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/referral/">
                    Referral Program
                  </a>
                </Button>

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/promo/">
                    Promotions
                  </a>
                </Button>

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://track.medsupplysolutions.com/">
                    Order tracker
                  </a>
                </Button>

                {isBankAcc && (
                  <Box mt={10} width={{ base: "100%", md: "100%" }}>
                    <Text fontWeight={700}>Red River Europe Ltd.</Text>
                    <Text color="#4A5568" fontSize="16px">
                      Andrea Panagidis, 41, 5285, Famagusta, Cyprus <br />
                      Phone: +357 22 007450 <br />
                      Name: Georgianna Joseph <br />
                      VAT# 10430203T <br />
                    </Text>
                  </Box>
                )}

                {isOtherBankUser && (
                  <Box mt={10} width={{ base: "100%", md: "100%" }}>
                    <Text fontWeight={700}>Strream Direct Marketing Ltd.</Text>
                    <Text color="#4A5568" fontSize="16px">
                      30 Eglinton Ave West, Unit 710 <br />
                      Mississauga, ON <br />
                      Canada, L5R3E7
                    </Text>
                  </Box>
                )}

                {isBankUser3 && (
                  <Box mt={10} width={{ base: "100%", md: "100%" }}>
                    <Text fontWeight={700}>Red River Supplies B.V.</Text>
                    <Text color="#4A5568" fontSize="16px">
                      1.04, Volmerlaan 7 <br />
                      Rijswijk, Netherlands, 2288
                    </Text>
                  </Box>
                )}
                {isBankUserEu && (
                  <Box width={{ base: "100%", md: "100%" }}>
                    <Text fontWeight={700}> Red River Supplies B.V. </Text>
                    <Text color="#4A5568" fontSize="16px">
                      1.04, Volmerlaan 7,
                      <br /> 2288, Rijswijk, Netherlands <br />
                    </Text>
                  </Box>
                )}
              </VStack>

              <VStack
                width="80%"
                alignItems="flex-start"
                ml={{ "2xl": "160px" }}
              >
                <Text
                  pt={{ base: "40px", md: "0px" }}
                  color="#BB5D82"
                  fontSize="16px"
                  fontWeight="700"
                >
                  Support
                </Text>

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/contact/">
                    Contact Us
                  </a>
                </Button>

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/terms-and-conditions/">
                    Terms of Service
                  </a>
                </Button>

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/privacy-policy/">
                    Privacy Policy
                  </a>
                </Button>

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/refund-policy/">
                    Refund Policy
                  </a>
                </Button>

                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/shipping/">
                    Shipping
                  </a>
                </Button>

                <Button
                  textAlign="start"
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/about-us/#faq">
                    FAQ
                  </a>
                </Button>
                <Button
                  color="#3B2060"
                  fontSize="14px"
                  _hover={{ background: "none" }}
                  variant="unstyled"
                >
                  <a href="https://www.medsupplysolutions.com/sitemap/">
                    Sitemap
                  </a>
                </Button>
              </VStack>
            </HStack>
          </Stack>

          <HStack
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            mt="40px"
            borderTop="1px solid #BB5D82"
          >
            <Text pt="24px" fontSize="12px" color="#3B2060">
              Copyright {today.getFullYear()}. Med Supply Solutions
            </Text>
            <HStack pt="24px">
              <VisaLogo />
              <MasterCardLogo />
            </HStack>
          </HStack>
        </VStack>
      </Box>
    </Box>
  );
};

export default Footer;
